import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Nav() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // Load saved theme
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="nav-left">
          <div className="nav-logo">
            <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
              kaspar tiri
            </Link>
          </div>
        </div>
        <div className="nav-right">
          <div className="nav-items">
            <Link to="/about" className="nav-item">about</Link>
            <Link to="/media" className="nav-item">media</Link>
            <Link to="/blog" className="nav-item">blog</Link>
          </div>
          <button 
            className="theme-toggle" 
            id="theme-toggle" 
            aria-label="Toggle theme"
            onClick={toggleTheme}
          >
            <span className="theme-icon">◐</span>
          </button>
        </div>
      </div>
    </nav>
  );
}

